import { Box, HStack, Text, Icon, Flex, Button, Spacer } from '@chakra-ui/react';
import ContentContainer from '~/containers/Content';

import { IoStopwatchOutline } from 'react-icons/io5';

type GroupingBarProps = {
  onCancel?: () => void;
};

export default function GroupingBar({ onCancel }: GroupingBarProps) {
  return (
    <Box px={4}>
      <ContentContainer>
        <Flex align="center">
          <HStack py={2}>
            <Icon as={IoStopwatchOutline} color="dark" boxSize="1.5rem" />
            <Text flex="1" fontWeight="bold">
              正在揪團中
            </Text>
          </HStack>
          <Spacer />
          <Button
            size="sm"
            color="gray.400"
            onClick={onCancel}
            variant="unstyled"
            fontWeight="normal"
          >
            取消揪團
          </Button>
        </Flex>
      </ContentContainer>
    </Box>
  );
}
